'use client'

import { forwardRef } from 'react'

import type { InputHTMLAttributes } from 'react'

type FileInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

/** 브라우저 파일 대화상자를 여는 입력. 외형은 호출부가 정한다(숨기거나 label 위에 투명하게 덮는다). */
export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  (props, ref) => <input ref={ref} type="file" {...props} />
)

FileInput.displayName = 'FileInput'
